<template>
  <i class="iconfont" :class="class">{{ code }}</i>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    code: {
      type: String,
    },
    class: {
      type: String,
    },
  },
})
</script>
